import { activateSlider } from "./ruins-slider";
const ruinsTabs = document.querySelector(".ruins__tab");

if (ruinsTabs) {
  ruinsTabs.addEventListener("click", (e) => {
    if (e.target.classList.contains("ruins__tab-button")) {
      const data = e.target.dataset.tab;
      const ruinsTab = document.getElementById("ruins");
      const artTab = document.getElementById("art");

      console.log(data);

      ruinsTabs
        .querySelectorAll(".ruins__tab-button")
        .forEach(
          (btn) =>
            btn.classList.contains("is-active") &&
            btn.classList.remove("is-active")
        );
      e.target.classList.add("is-active");

      switch (data) {
        case "art":
          ruinsTab.classList.remove("active");
          artTab.classList.add("active");
          activateSlider(document.querySelector(".active .ruin__list"))
          break;
        case "ruins":
          ruinsTab.classList.add("active");
          artTab.classList.remove("active");
          activateSlider(document.querySelector(".active .ruin__list"))
          break;
      }
    }
  });
}
